"use client";

import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { usePathname } from "@opensea/navigation";
import deepEqual from "fast-deep-equal";
import { useEffect, useRef, useState } from "react";
import { isItemIdentifier } from "../../utils";
import { ItemViewModal } from "./ItemViewModal";
import { ItemViewModalFragment } from "./ItemViewModal.fragment";
import { ItemViewModalContext } from "./item-view-modal-context";
export function ItemViewModalProvider(t0) {
  const $ = _c(16);
  const {
    children
  } = t0;
  const [item, setItem] = useState(null);
  let t1;
  if ($[0] !== item) {
    t1 = function handleSetItem(newItem) {
      if (!deepEqual(item, newItem)) {
        setItem(isItemIdentifier(newItem) ? newItem : readFragment(ItemViewModalFragment, newItem));
      }
    };
    $[0] = item;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleSetItem = t1;
  const hasTransitioned = useRef(false);
  const pathname = usePathname();
  let t2;
  if ($[2] !== handleSetItem) {
    t2 = function handleClosed() {
      handleSetItem(null);
    };
    $[2] = handleSetItem;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleClosed = t2;
  let t3;
  if ($[4] !== handleSetItem || $[5] !== pathname) {
    t3 = () => {
      if (hasTransitioned.current && !pathname.includes("item")) {
        handleSetItem(null);
        hasTransitioned.current = false;
      }
      if (pathname.includes("item")) {
        hasTransitioned.current = true;
      }
    };
    $[4] = handleSetItem;
    $[5] = pathname;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== pathname) {
    t4 = [pathname];
    $[7] = pathname;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  useEffect(t3, t4);
  let t5;
  if ($[9] !== handleClosed || $[10] !== item) {
    t5 = item ? <ItemViewModal item={item} onClosed={handleClosed} open={Boolean(item)} /> : null;
    $[9] = handleClosed;
    $[10] = item;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== children || $[13] !== handleSetItem || $[14] !== t5) {
    t6 = <ItemViewModalContext.Provider value={handleSetItem}>{children}{t5}</ItemViewModalContext.Provider>;
    $[12] = children;
    $[13] = handleSetItem;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}